<template>
  <div class="game-info-detail">
    <div class="game-info-detail-wrap">
      <navBar
        :useTitle="$padFalg == 'other'"
        :callBack="goList"
        title="百科"
      ></navBar>
      <div class="game-info-main">
        <component :is="currentComponent" :detailData="detailData"></component>
      </div>
      <!-- <div
        class="game-info-strategy"
        v-if="currentComponent === 'technicianPage'"
      >
        <strategy :strategyList="strategyList"></strategy>
      </div> -->
    </div>
  </div>
</template>

<script>
import genDesc from "../tools/reg.js";
import navBar from "../components/base/navBar.vue";
import technicianPage from "./technicianPage.vue";
import mechPage from "./mechPage.vue";
import weaponPage from "./weaponPage.vue";
import modulePage from "./modulePage.vue";
import componentsPage from "./componentsPage.vue";
import packPage from "./packPage.vue";
import strategy from "../components/strategy.vue";
import loadsh from "lodash";
import getCdnImg from "@/utils/getCdnImg.js";
const mechLiveImg = getCdnImg(
  "//media.tentree-games.com/media/pictures/community/img/gl/gameInfo/mechaLive/"
);
const mechPartIcon = getCdnImg(
  "//media.tentree-games.com/media/pictures/community/img/gl/gameInfo/waparts/"
);
const techImg = getCdnImg(
  "//media.tentree-games.com/media/pictures/community/img/gl/gameInfo/character/"
);
const packImg = getCdnImg(
  "//media.tentree-games.com/media/pictures/community/img/gl/gameInfo/pack/"
);
const weponImg = getCdnImg(
  "//media.tentree-games.com/media/pictures/community/img/gl/gameInfo/weapons/"
);
const occImg = getCdnImg(
  "//media.tentree-games.com/media/pictures/community/img/gl/gameInfo/occupation/"
);
const skillImg = getCdnImg(
  "//media.tentree-games.com/media/pictures/community/img/gl/gameInfo/skill/"
);
import axios from "@/api/get";
const { getGlGameinfo, getTechRelateInfo } = axios;
export default {
  name: "gameInfoDetail",
  props: {
    type: {
      type: Number, //one of typeEnum
      default: 1,
    },
    id: {
      type: Number | String,
      default: "0",
    },
  },
  components: {
    navBar,
    technicianPage,
    mechPage,
    weaponPage,
    packPage,
    strategy,
    modulePage,
    componentsPage,
  },
  data() {
    return {
      detailData: {},
      strategyList: [],
    };
  },
  created() {
    this.$emit("getTabView", false);
    let form = {
      appkey: "1705460260139",
      target: this.currentDataSource,
      type: "detail",
      query: this.id,
    };
    getGlGameinfo(form).then(async (res) => {
      let data = res.data && res.data.data ? res.data.data : {};
      this.detailData = this.genDetailData(this.type, data);
      if (this.currentComponent === "technicianPage") {
        let strategyData = await getTechRelateInfo({ relateId: this.id });
        if (
          strategyData &&
          strategyData.data &&
          strategyData.data.data &&
          strategyData.data.data.length > 0
        ) {
          let resData = strategyData.data.data;
          this.strategyList = resData.map((item) => {
            return {
              id: item.id ? item.id : null,
              src: item.thumbnail ? item.thumbnail : "",
              title: item.title ? item.title : "-",
              content: item.description ? item.description : "-",
            };
          });
        } else {
          this.strategyList = [];
        }
      }
    });
  },
  computed: {
    currentComponent() {
      switch (this.type) {
        case 1:
          return "technicianPage";
        case 2:
          return "mechPage";
        case 3:
          return "weaponPage";
        case 4:
          return "packPage";
        case 5:
          return "modulePage";
        case 6:
          return "componentsPage";
      }
    },
    currentDataSource() {
      switch (this.type) {
        case 1:
          return "pilot_data";
        case 2:
          return "aircraft_data";
        case 3:
          return "weapon_data";
        case 4:
          return "backpack_data";
        case 5:
          return "module_props";
        case 6:
          return "component_props";
      }
    },
  },
  methods: {
    getAttack(type, val) {
      if (!type || !val) {
        return "-";
      }
      let tenBullet = ["MachineGun", "HeavyMachineGun"];
      let twelvebullet = ["ShotGun"];
      let eightPercent = ["Flamethrower"];
      if (tenBullet.includes(type)) {
        return loadsh.round(Number(val) / 10) + "x10";
      } else if (twelvebullet.includes(type)) {
        return loadsh.round(Number(val) / 12) + "x12";
      } else if (eightPercent.includes(type)) {
        return loadsh.round(Number(val) / 8) + "x8";
      } else {
        return val + "x1";
      }
    },
    getPartMove(val) {
      if (!val) {
        return "";
      }
      return Number(val) / 1000;
    },
    getCellTitle(attr) {
      switch (attr) {
        case "0": {
          return "能力提升";
        }
        case "1": {
          return "神經驅動解锁";
        }
        case "2": {
          return "能力提升";
        }
        case "3": {
          return "";
        }
        case "4": {
          return "";
        }
        case "5": {
          return "能力提升";
        }
        case "6": {
          return "職業能力解锁";
        }
      }
    },
    getAttributes(data) {
      if (!data) {
        return "";
      }
      let attributes = [];
      let titleMap = [
        { key: "PilotBasePropertyAssaultAdd", value: "突擊" },
        { key: "PilotBasePropertyDefenseAdd", value: "防禦" },
        { key: "PilotBasePropertyMeleeAdd", value: "格鬥" },
        { key: "PilotBasePropertyMechanicAdd", value: "工程" },
        { key: "PilotBasePropertySnipeAdd", value: "射擊" },
        { key: "PilotBasePropertyRangedAdd", value: "戰術" },
        { key: "PilotAlphaChipBandwidthAdd", value: "α算力上限" },
        { key: "PilotBetaChipBandwidthAdd", value: "β算力上限" },
        { key: "PilotGammaChipBandwidthAdd", value: "γ算力上限" },
      ];
      attributes = data.split(":");
      if (attributes.length == 2) {
        let title = titleMap.find((item) => item.key == attributes[0]);
        if (!title) {
          return "";
        }
        return `<p>${title.value} <span style="color:#2faa57">+${attributes[1]}</span></p>`;
      } else {
        return "";
      }
    },
    getSolt(originData, index) {
      let splitData = originData.split("/");
      return splitData[index];
    },
    getOccIconClass(occ) {
      switch (occ) {
        case "Assault":
          return "1";
        case "Striker":
          return "2";
        case "Gunner":
          return "3";
        case "Launcher":
          return "4";
        case "Mechanic":
          return "5";
        case "Defender":
          return "6";
        default:
          return "";
      }
    },
    getQuality(quality) {
      switch (quality) {
        case "SSSR":
          return "SS";
        case "UR":
          return "S+";
        case "SSR":
          return "S";
        case "SR":
          return "A";
        case "R":
          return "B";
        case "C":
          return "C";
        default:
          return "-";
      }
    },
    getDriveAllow(driveAllow) {
      switch (driveAllow) {
        case "Heavy":
          return "重型";
        case "Medium":
          return "中型";
        case "Light":
          return "輕型";
      }
    },
    getSKillType(val) {
      switch (val) {
        case "EquipmentSkill":
          return "主動技能";
        case "Order":
          return "指令";
        case "SpecialAssault":
          return "指令";
      }
    },
    isPassive(val) {
      return !["EquipmentSkill", "Order", "SpecialAssault"].includes(val);
    },
    getFullLevelData(data, attr) {
      if (data.manji) {
        if (data.manji.hasOwnProperty(attr)) {
          return data.manji[attr];
        } else {
          return data[attr];
        }
      } else {
        return data[attr];
      }
    },
    goList() {
      this.$emit("goList");
    },
    //在这里进行后端数据重组
    genDetailData(type, data) {
      switch (type) {
        case 1:
          let result = {
            name: data.name,
            liveSrc: techImg(`${data.AvatarHeroIcon}.png`),
            occIcon: null,
            desc: data.Introduction,
            technianRecordData: [],
            neuralDrive: {},
            talentData: {},
            baseData: {},
            neuralComputer: {
              type: null,
              data: [],
            },
          };
          result.occIcon = this.getOccIconClass(data.Profession);
          result.technianRecordData = [
            { title: "稱呼", content: data.name },
            { title: "姓名", content: data.RealName },
            {
              title: "性别",
              content: data.Gender
                ? data.Gender == "Male"
                  ? "男"
                  : "女"
                : "-",
            },
            { title: "血型", content: data.BloodType },
            {
              title: "身高",
              content: data.Height ? `${data.Height}厘米` : "-",
            },
          ];
          if (
            data.AdditionalInformation &&
            data.AdditionalInformation.length > 0
          ) {
            let extraInformation = data.AdditionalInformation.map((item) => {
              return {
                title: item.AdditionalInformationTitle,
                content: item.AdditionalInformationContent,
              };
            });
            result.technianRecordData = result.technianRecordData.concat(
              extraInformation
            );
          }
          result.baseData = {
            origin: {
              occupation: data.Occupation,
              quality: this.getQuality(data.quality),
              driveAllow: this.getDriveAllow(
                data.AllowedMechaDriveList_DriveAllowedList
              ),
              driveLevel: data.MechaDriveLevel,
              camp: data.Camp,
              combat: data.Combat,
              assault: data.Assault,
              shooting: data.Shooting,
              tactics: data.Tactics,
              defense: data.Defense,
              engineering: data.Engineering,
              apInit: data.InitialPilotAPValue_PilotAPInitBase,
              apMax: data.MaximumPilotAPValue_PilotAPMaxBase,
              apRecover: data.PilotAPRecoveryperTurn_PilotAPRecoverBase,
            },
            full: {
              occupation: data.Occupation,
              quality: this.getQuality(this.getFullLevelData(data, "quality")),
              driveAllow: this.getDriveAllow(
                data.AllowedMechaDriveList_DriveAllowedList
              ),
              driveLevel: this.getFullLevelData(data, "MechaDriveLevel"),
              camp: data.Camp,
              combat: this.getFullLevelData(data, "Combat"),
              assault: this.getFullLevelData(data, "Assault"),
              shooting: this.getFullLevelData(data, "Shooting"),
              tactics: this.getFullLevelData(data, "Tactics"),
              defense: this.getFullLevelData(data, "Defense"),
              engineering: this.getFullLevelData(data, "Engineering"),
              apInit: this.getFullLevelData(
                data,
                "InitialPilotAPValue_PilotAPInitBase"
              ),
              apMax: this.getFullLevelData(
                data,
                "MaximumPilotAPValue_PilotAPMaxBase"
              ),
              apRecover: this.getFullLevelData(
                data,
                "PilotAPRecoveryperTurn_PilotAPRecoverBase"
              ),
            },
          };
          result.talentData = {
            origin: {
              name: data.Talent0_2Ability.name,
              type: "被動技能",
              expend: "-",
              weapon: "-",
              desc: genDesc(
                data.Talent0_2Ability.SpecificEffects,
                "#F74848",
                "#5c7338"
              ),
              icon: skillImg(`${data.Talent0_2Ability.icon}.png`),
            },
            full: {
              name: data.Talent3_5Ability.name,
              type: "被動技能",
              expend: "-",
              weapon: "-",
              desc: genDesc(
                data.Talent3_5Ability.SpecificEffects,
                "#F74848",
                "#5c7338"
              ),
              icon: skillImg(`${data.Talent0_2Ability.icon}.png`),
            },
          };
          //TODO 判断是否有神经连接
          let driveType =
            data.NeuralDriveTemplate &&
            data.NeuralDriveTemplate.ListChipPartition
              ? data.NeuralDriveTemplate.ListChipPartition.length > 3
                ? true
                : false
              : false;
          if (
            data.NeuralDriveTemplate &&
            data.NeuralDriveTemplate.ListChipPartition
          ) {
            result.neuralDrive = driveType
              ? {
                  alpha: {
                    slot1: this.getSolt(
                      data.NeuralDriveTemplate.ListChipPartition[0]
                        .ListAssembled,
                      0
                    ),
                    slot2: this.getSolt(
                      data.NeuralDriveTemplate.ListChipPartition[0]
                        .ListAssembled,
                      1
                    ),
                    slot3: this.getSolt(
                      data.NeuralDriveTemplate.ListChipPartition[0]
                        .ListAssembled,
                      2
                    ),
                    level1: genDesc(
                      data.NeuralDriveTemplate.ListChipPartition[0]
                        .ListActivationEffects[0].PassiveSkill.SpecificEffects
                    ),
                    level2: genDesc(
                      data.NeuralDriveTemplate.ListChipPartition[0]
                        .ListActivationEffects[1].PassiveSkill.SpecificEffects
                    ),
                    level3: genDesc(
                      data.NeuralDriveTemplate.ListChipPartition[0]
                        .ListActivationEffects[2].PassiveSkill.SpecificEffects
                    ),
                  },
                  beta: {
                    slot1: this.getSolt(
                      data.NeuralDriveTemplate.ListChipPartition[1]
                        .ListAssembled,
                      0
                    ),
                    slot2: this.getSolt(
                      data.NeuralDriveTemplate.ListChipPartition[1]
                        .ListAssembled,
                      1
                    ),
                    slot3: this.getSolt(
                      data.NeuralDriveTemplate.ListChipPartition[1]
                        .ListAssembled,
                      2
                    ),
                    level1: genDesc(
                      data.NeuralDriveTemplate.ListChipPartition[1]
                        .ListActivationEffects[0].PassiveSkill.SpecificEffects
                    ),
                    level2: genDesc(
                      data.NeuralDriveTemplate.ListChipPartition[1]
                        .ListActivationEffects[1].PassiveSkill.SpecificEffects
                    ),
                    level3: genDesc(
                      data.NeuralDriveTemplate.ListChipPartition[1]
                        .ListActivationEffects[2].PassiveSkill.SpecificEffects
                    ),
                  },
                  gamma1: {
                    slot1: this.getSolt(
                      data.NeuralDriveTemplate.ListChipPartition[2]
                        .ListAssembled,
                      0
                    ),
                    slot2: this.getSolt(
                      data.NeuralDriveTemplate.ListChipPartition[2]
                        .ListAssembled,
                      1
                    ),
                    slot3: this.getSolt(
                      data.NeuralDriveTemplate.ListChipPartition[2]
                        .ListAssembled,
                      2
                    ),
                    level1: genDesc(
                      data.NeuralDriveTemplate.ListChipPartition[2]
                        .ListActivationEffects[0].PassiveSkill.SpecificEffects
                    ),
                    level2: genDesc(
                      data.NeuralDriveTemplate.ListChipPartition[2]
                        .ListActivationEffects[1].PassiveSkill.SpecificEffects
                    ),
                    level3: genDesc(
                      data.NeuralDriveTemplate.ListChipPartition[2]
                        .ListActivationEffects[2].PassiveSkill.SpecificEffects
                    ),
                    level4: genDesc(
                      data.NeuralDriveTemplate.ListChipPartition[2]
                        .ListActivationEffects[3].PassiveSkill.SpecificEffects
                    ),
                    level5: genDesc(
                      data.NeuralDriveTemplate.ListChipPartition[2]
                        .ListActivationEffects[4].PassiveSkill.SpecificEffects
                    ),
                    level6: genDesc(
                      data.NeuralDriveTemplate.ListChipPartition[2]
                        .ListActivationEffects[5].PassiveSkill.SpecificEffects
                    ),
                  },
                  gamma2: {
                    slot1: this.getSolt(
                      data.NeuralDriveTemplate.ListChipPartition[3]
                        .ListAssembled,
                      0
                    ),
                    slot2: this.getSolt(
                      data.NeuralDriveTemplate.ListChipPartition[3]
                        .ListAssembled,
                      1
                    ),
                    slot3: this.getSolt(
                      data.NeuralDriveTemplate.ListChipPartition[3]
                        .ListAssembled,
                      2
                    ),
                    level1: genDesc(
                      data.NeuralDriveTemplate.ListChipPartition[3]
                        .ListActivationEffects[0].PassiveSkill.SpecificEffects
                    ),
                    level2: genDesc(
                      data.NeuralDriveTemplate.ListChipPartition[3]
                        .ListActivationEffects[1].PassiveSkill.SpecificEffects
                    ),
                    level3: genDesc(
                      data.NeuralDriveTemplate.ListChipPartition[3]
                        .ListActivationEffects[2].PassiveSkill.SpecificEffects
                    ),
                    level4: genDesc(
                      data.NeuralDriveTemplate.ListChipPartition[3]
                        .ListActivationEffects[3].PassiveSkill.SpecificEffects
                    ),
                    level5: genDesc(
                      data.NeuralDriveTemplate.ListChipPartition[3]
                        .ListActivationEffects[4].PassiveSkill.SpecificEffects
                    ),
                    level6: genDesc(
                      data.NeuralDriveTemplate.ListChipPartition[3]
                        .ListActivationEffects[5].PassiveSkill.SpecificEffects
                    ),
                  },
                }
              : {
                  alpha: {
                    slot1: this.getSolt(
                      data.NeuralDriveTemplate.ListChipPartition[0]
                        .ListAssembled,
                      0
                    ),
                    slot2: this.getSolt(
                      data.NeuralDriveTemplate.ListChipPartition[0]
                        .ListAssembled,
                      1
                    ),
                    slot3: this.getSolt(
                      data.NeuralDriveTemplate.ListChipPartition[0]
                        .ListAssembled,
                      2
                    ),
                    level1: genDesc(
                      data.NeuralDriveTemplate.ListChipPartition[0]
                        .ListActivationEffects[0].PassiveSkill.SpecificEffects
                    ),
                    level2: genDesc(
                      data.NeuralDriveTemplate.ListChipPartition[0]
                        .ListActivationEffects[1].PassiveSkill.SpecificEffects
                    ),
                    level3: genDesc(
                      data.NeuralDriveTemplate.ListChipPartition[0]
                        .ListActivationEffects[2].PassiveSkill.SpecificEffects
                    ),
                  },
                  beta: {
                    slot1: this.getSolt(
                      data.NeuralDriveTemplate.ListChipPartition[1]
                        .ListAssembled,
                      0
                    ),
                    slot2: this.getSolt(
                      data.NeuralDriveTemplate.ListChipPartition[1]
                        .ListAssembled,
                      1
                    ),
                    slot3: this.getSolt(
                      data.NeuralDriveTemplate.ListChipPartition[1]
                        .ListAssembled,
                      2
                    ),
                    level1: genDesc(
                      data.NeuralDriveTemplate.ListChipPartition[1]
                        .ListActivationEffects[0].PassiveSkill.SpecificEffects
                    ),
                    level2: genDesc(
                      data.NeuralDriveTemplate.ListChipPartition[1]
                        .ListActivationEffects[1].PassiveSkill.SpecificEffects
                    ),
                    level3: genDesc(
                      data.NeuralDriveTemplate.ListChipPartition[1]
                        .ListActivationEffects[2].PassiveSkill.SpecificEffects
                    ),
                  },
                  gamma: {
                    slot1: this.getSolt(
                      data.NeuralDriveTemplate.ListChipPartition[2]
                        .ListAssembled,
                      0
                    ),
                    slot2: this.getSolt(
                      data.NeuralDriveTemplate.ListChipPartition[2]
                        .ListAssembled,
                      1
                    ),
                    slot3: this.getSolt(
                      data.NeuralDriveTemplate.ListChipPartition[2]
                        .ListAssembled,
                      2
                    ),
                    level1: genDesc(
                      data.NeuralDriveTemplate.ListChipPartition[2]
                        .ListActivationEffects[0].PassiveSkill.SpecificEffects
                    ),
                    level2: genDesc(
                      data.NeuralDriveTemplate.ListChipPartition[2]
                        .ListActivationEffects[1].PassiveSkill.SpecificEffects
                    ),
                    level3: genDesc(
                      data.NeuralDriveTemplate.ListChipPartition[2]
                        .ListActivationEffects[2].PassiveSkill.SpecificEffects
                    ),
                    level4: genDesc(
                      data.NeuralDriveTemplate.ListChipPartition[2]
                        .ListActivationEffects[3].PassiveSkill.SpecificEffects
                    ),
                    level5: genDesc(
                      data.NeuralDriveTemplate.ListChipPartition[2]
                        .ListActivationEffects[4].PassiveSkill.SpecificEffects
                    ),
                    level6: genDesc(
                      data.NeuralDriveTemplate.ListChipPartition[2]
                        .ListActivationEffects[5].PassiveSkill.SpecificEffects
                    ),
                  },
                };
          }

          if (
            data.biomimetic_computer_data &&
            data.biomimetic_computer_data.length > 0
          ) {
            let neuralComputerData = [];
            data.biomimetic_computer_data.forEach((item) => {
              let cellData = {};
              let type =
                item.hasOwnProperty("skill") && item.UnitType != "6"
                  ? "2"
                  : "1";
              let cellType = item.UnitType;
              cellData.type = type;
              cellData.id = Number(item.LocationOnMap);
              if (type == "1" && item.UnitType != "6") {
                cellData.src = "";
                cellData.title = this.getCellTitle(cellType);
                cellData.desc = item.hasOwnProperty("describe")
                  ? genDesc(item.describe, "#ff4442", "#d3a61f")
                  : this.getAttributes(item.AttributeBonus);
              }
              if (type == "2" && item.UnitType != "6") {
                cellData.src =
                  cellType == "6"
                    ? occImg(`${item.icon}.png`)
                    : skillImg(`${item.skill.icon}.png`);
                cellData.title = this.getCellTitle(cellType);
                cellData.skillName = item.skill.name;
                cellData.hasWeapon =
                  item.skill.type === "EquipmentSkill" ||
                  this.isPassive(item.skill.type);
                cellData.skillType = item.skill.type
                  ? this.getSKillType(item.skill.type)
                  : "被動技能";
                cellData.skillSpend = this.isPassive(item.skill.type)
                  ? "-"
                  : item.skill.hasOwnProperty("Ap")
                  ? `${item.skill.Ap}技力`
                  : "0AP";
                cellData.skillCd = this.isPassive(item.skill.type)
                  ? "-"
                  : item.skill.hasOwnProperty("CD")
                  ? `${item.skill.CD}回合`
                  : "0回合";
                cellData.weaponType = this.isPassive(item.skill.type)
                  ? "-"
                  : item.skill.hasOwnProperty("matchingWeaponType")
                  ? item.skill.matchingWeaponType
                  : "-";
                cellData.skillDesc = item.skill.hasOwnProperty("describe")
                  ? genDesc(item.skill.describe, "#ff4442", "#d3a61f")
                  : genDesc(item.skill.SpecificEffects);
                cellData.powerDesc = item.hasOwnProperty("describe")
                  ? genDesc(item.describe, "#ff4442", "#d3a61f")
                  : this.getAttributes(item.AttributeBonus);
              }
              if (item.UnitType == "6") {
                cellData.src = occImg(`${item.icon}.png`);
                cellData.title = this.getCellTitle(cellType);
                cellData.desc = item.hasOwnProperty("skill")
                  ? genDesc(item.skill.SpecificEffects, "#ff4442", "#d3a61f")
                  : "-";
              }
              neuralComputerData.push(cellData);
            });
            neuralComputerData.sort((a, b) => {
              return a.id - b.id;
            });
            result.neuralComputer.type = data.biomimetic_computer_type;
            result.neuralComputer.data = neuralComputerData;
          }
          return result;
        case 2:
          let result2 = {
            liveSrc: null,
            origin: {
              bodyInfo: {},
              rightArmInfo: {},
              leftArmInfo: {},
              legInfo: {},
              moduleInfo: [],
            },
            full: {
              bodyInfo: {},
              rightArmInfo: {},
              leftArmInfo: {},
              legInfo: {},
              moduleInfo: [],
            },
            desc: null,
          };
          let attrMap = {
            //处理后端字段映射
            partQuality: "quality",
            partFire: "fire",
            partDurability: "durable",
            partPower: "output",
            partArmor: "Armor",
            partWeight: "aircraftWeight",
            partAnti: "Antiriot",
            partPort: "Interface",
            partDodge: "Dodge",
            partMove: {
              key: "move",
              filter: "getPartMove",
            },
            partHit: "Hit",
            partIcon: "mechaIcon",
          };
          let infoList = [
            {
              key: "軀幹", //查找后端对象的key
              target: "bodyInfo", //目标对象
              attrs: [
                "partIcon",
                "partName",
                "partQuality",
                "partFire",
                "partDurability",
                "partArmor",
                "partPower",
                "partWeight",
                "partAnti",
                "partPort",
              ], //对象需要的字段
            },
            {
              key: "左臂",
              target: "leftArmInfo",
              attrs: [
                "partIcon",
                "partName",
                "partQuality",
                "partFire",
                "partDurability",
                "partArmor",
                "partHit",
                "partWeight",
                "partPort",
              ],
            },
            {
              key: "右臂",
              target: "rightArmInfo",
              attrs: [
                "partIcon",
                "partName",
                "partQuality",
                "partFire",
                "partDurability",
                "partArmor",
                "partHit",
                "partWeight",
                "partPort",
              ],
            },
            {
              key: "腿部",
              target: "legInfo",
              attrs: [
                "partIcon",
                "partName",
                "partQuality",
                "partFire",
                "partDurability",
                "partArmor",
                "partDodge",
                "partWeight",
                "partMove",
                "partPort",
              ],
            },
          ];
          infoList.forEach((item) => {
            let bodyData = data.find((d) => d.position == item.key);
            if (bodyData) {
              let bodyFullData = bodyData.manji || {};
              for (let i = 0; i < item.attrs.length; i++) {
                let attr = item.attrs[i];
                if (attr == "partName") {
                  result2.origin[item.target].partName = result2.full[
                    item.target
                  ].partName = `${bodyData.name}-${bodyData.position}`;
                } else if (attr == "partIcon") {
                  result2.origin[item.target].partIcon = result2.full[
                    item.target
                  ].partIcon = bodyData.mechaIcon
                    ? mechPartIcon(`${bodyData.mechaIcon}.png`)
                    : "";
                } else if (typeof attrMap[attr] == "string") {
                  result2.origin[item.target][attr] =
                    bodyData[attrMap[attr]] || "-";
                  result2.full[item.target][attr] =
                    bodyData[attrMap[attr]] || "-"; //有些不变的字段先赋值一次
                  if (bodyFullData.hasOwnProperty(attrMap[attr])) {
                    result2.full[item.target][attr] =
                      bodyFullData[attrMap[attr]] || "-";
                  }
                } else {
                  let filterData = bodyData[attrMap[attr].key];
                  let filterFullData = bodyFullData[attrMap[attr].key];
                  result2.origin[item.target][attr] = this[
                    attrMap[attr].filter
                  ](filterData);
                  result2.full[item.target][attr] = this[attrMap[attr].filter](
                    filterData
                  );
                  if (bodyFullData.hasOwnProperty(attrMap[attr].key)) {
                    result2.full[item.target][attr] = this[
                      attrMap[attr].filter
                    ](filterFullData);
                  }
                }
              }
            }
          });
          if (
            data[0] &&
            data[0].ModuleCarried &&
            data[0].ModuleCarried.length > 0
          ) {
            let mouldeData = data[0].ModuleCarried.map((item) => {
              return {
                moduleIcon: item.icon ? skillImg(`${item.icon}.png`) : "",
                moduleName: item.name
                  ? item.level
                    ? `${item.name}lv${item.level}`
                    : item.name
                  : "-",
                moduleDesc: item.SpecificEffects
                  ? genDesc(item.SpecificEffects, "#F74848")
                  : "-",
              };
            });
            result2.origin.moduleInfo = mouldeData;
          }
          if (
            data[0] &&
            data[0].manji &&
            data[0].manji.ModuleCarried &&
            data[0].manji.ModuleCarried.length > 0
          ) {
            result2.full.moduleInfo = data[0].manji.ModuleCarried.map(
              (item) => {
                return {
                  moduleIcon: item.icon ? skillImg(`${item.icon}.png`) : "",
                  moduleName: item.name
                    ? item.level
                      ? `${item.name}lv${item.level}`
                      : item.name
                    : "-",
                  moduleDesc: item.SpecificEffects
                    ? genDesc(item.SpecificEffects, "#F74848")
                    : "-",
                };
              }
            );
          }
          result2.liveSrc = data[0]
            ? data[0].lihuiIcon
              ? mechLiveImg(`${data[0].lihuiIcon}.jpg`)
              : ""
            : "";
          result2.desc = data[0] ? data[0].introduce : "-";
          return result2;
        case 3:
          let result3 = {
            liveSrc: null,
            quality: null,
            gain: null,
            type: null,
            weaponData: [],
            desc: null,
          };
          if (data && data.length > 0) {
            let firstData = data[0];
            let weaponData = [];
            result3.liveSrc = firstData.icon
              ? weponImg(`${firstData.icon}.png`)
              : "";
            result3.quality = firstData.quality ? firstData.quality : "R";
            result3.gain = firstData.gain ? firstData.gain : "-";
            result3.type = firstData.WeaponType2 ? firstData.WeaponType2 : "";
            result3.desc = firstData.describe ? firstData.describe : "-";
            data.forEach((item) => {
              let weaponSkill = [];
              if (
                item.hasOwnProperty("PassiveSkill") &&
                item.PassiveSkill.length > 0
              ) {
                item.PassiveSkill.forEach((sk) => {
                  let passiveSkill = {
                    skillIcon: "",
                    skillType: "",
                    skillExpend: "",
                    skillCd: "",
                    skillName: "",
                    skillDesc: "",
                  };

                  passiveSkill.skillIcon = sk.icon
                    ? skillImg(`${sk.icon}.png`)
                    : "";
                  passiveSkill.skillType = "被動技能";
                  passiveSkill.skillExpend = "-";
                  passiveSkill.skillCd = "-";
                  passiveSkill.skillName = sk.name ? sk.name : "-";
                  passiveSkill.skillDesc = sk.SpecificEffects
                    ? genDesc(sk.SpecificEffects)
                    : "-";

                  weaponSkill.push(passiveSkill);
                });
              }
              if (
                item.hasOwnProperty("InitiativeSkill") &&
                item.InitiativeSkill.length > 0
              ) {
                item.InitiativeSkill.forEach((sk) => {
                  let initiativeSkill = {
                    skillIcon: "",
                    skillType: "",
                    skillExpend: "",
                    skillCd: "",
                    skillName: "",
                    skillDesc: "",
                  };

                  initiativeSkill.skillIcon = sk.icon
                    ? skillImg(`${sk.icon}.png`)
                    : "";
                  initiativeSkill.skillType = [
                    "SpecialAssault",
                    "Order",
                  ].includes(sk.type)
                    ? "指令"
                    : "主动技能";
                  initiativeSkill.skillExpend = sk.Ap ? sk.Ap : "-";
                  initiativeSkill.skillCd = sk.CD ? sk.CD : "-";
                  initiativeSkill.skillName = sk.name ? sk.name : "-";
                  initiativeSkill.skillDesc = sk.describe
                    ? genDesc(sk.describe)
                    : "-";

                  weaponSkill.push(initiativeSkill);
                });
              }
              weaponData.push({
                name: item.name ? item.name : "-",
                weaponType: item.WeaponType2 ? item.WeaponType2 : "-",
                weaponLevel: item.grade ? item.grade : "-",
                weaponPosition: item.RestrictionsPositionOfWeapon
                  ? item.RestrictionsPositionOfWeapon
                  : "-",
                weaponQuality: item.quality
                  ? this.getQuality(item.quality)
                  : "-",
                hit: item.WeaponHitPoint ? item.WeaponHitPoint : "-",
                weakPoint: item.WeaponUnderstanding
                  ? item.WeaponUnderstanding
                  : "-",
                attack: item.WeaponBasicAttackingPower
                  ? this.getAttack(
                      item.WeaponType2,
                      item.WeaponBasicAttackingPower
                    )
                  : "-",
                shieldDurability: item.ShieldbloodBase
                  ? item.ShieldbloodBase
                  : "-",
                gunshot: item.range ? item.range : "-",
                weight: item.WeaponWeight ? item.WeaponWeight : "-",
                bombLoad: item.NumberOfBullets ? item.NumberOfBullets : "-", //弹药量
                //reload: item.cd ? item.cd : '-', //冷卻
                skill: weaponSkill,
              });
            });
            result3.weaponData = weaponData;
          }
          return result3;
        case 4:
          let result4 = {
            packName: null,
            liveSrc: null,
            packQuality: null,
            gain: null,
            packWeight: null, //重量
            skill: [],
            desc: null,
            repair: null,
          };
          if (data) {
            result4.packName = data.name ? data.name : "-";
            result4.repair = data.AmountOfRepair ? data.AmountOfRepair : null;
            result4.liveSrc = data.BackpackIcon
              ? packImg(`${data.BackpackIcon}.png`)
              : "";
            result4.packQuality = data.quality ? data.quality : "R";
            result4.gain = data.HowGet ? data.HowGet : "-";
            result4.desc = data.RelatedDescription
              ? data.RelatedDescription
              : "-";
            result4.packWeight = data.weight ? data.weight : "-";
            //result4.skillName = data.Skill ? data.Skill.name ? data.Skill.name : '-' : '-'
            if (data.WithPassiveSkills && data.WithPassiveSkills.length > 0) {
              result4.skill = data.WithPassiveSkills.map((item) => {
                return {
                  skillIcon: item.icon ? skillImg(`${item.icon}.png`) : "",
                  skillExpend: "-",
                  skillCd: "-",
                  skillName: item.name ? item.name : "-",
                  skillDesc: item.SpecificEffects
                    ? genDesc(item.SpecificEffects)
                    : "-",
                };
              });
            } else {
              result4.skill = [];
            }
          }
          return result4;
        case 5:
          let result5 = {
            modeleName: null,
            addModuleLevel: null,
            quality: null,
            levelInfo: [],
            gain: null,
            desc: null,
            src: null,
            IconType: null,
          };
          if (data) {
            result5.modeleName = data.name ? data.name : "-";
            result5.src = data.icon ? skillImg(`${data.icon}.png`) : "";
            result5.addModuleLevel = data.EntryLevel ? data.EntryLevel : "-";
            result5.gain = data.ObtainingMethod ? data.ObtainingMethod : "-";
            result5.desc = data.introduce ? data.introduce : "-";
            result5.quality = data.quality ? data.quality : "R";
            result5.IconType = data.IconType ? data.IconType : "-";
            if (data.WithPassiveSkills && data.WithPassiveSkills.length > 0) {
              data.WithPassiveSkills.forEach((item, index) => {
                let cellData = {
                  level: index + 1,
                  content: item.SpecificEffects
                    ? genDesc(item.SpecificEffects)
                    : "-",
                };
                result5.levelInfo.push(cellData);
              });
            }
          }
          return result5;
        case 6:
          let result6 = {
            componentName: null,
            quality: null,
            probabilityLevel: null,
            moduleSubtype: null,
            src: null,
            moduleDescription: null,
            IconType: null,
            attention: null,
          };
          if (data) {
            result6.componentName = data.name ? data.name : "-";
            result6.quality = data.quality ? data.quality : "R";
            result6.probabilityLevel = data.ProbabilityLevel
              ? data.ProbabilityLevel
              : "-";
            result6.moduleSubtype = data.ModuleSubtype
              ? data.ModuleSubtype
              : "-";
            result6.src = data.icon ? skillImg(`${data.icon}.png`) : "";
            result6.moduleDescription = data.ModuleDescription
              ? genDesc(data.ModuleDescription)
              : "-";
            result6.IconType = data.IconType ? data.IconType : "-";
            result6.attention = data.attention ? data.attention : "-";
          }
          return result6;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.game-info-detail {
  width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  overflow-x: hidden;

  &-wrap {
    width: 7.5rem;
    padding-bottom: 2rem;
  }

  .game-info-main {
    background-color: white;
    padding: 1.7rem 0.21rem 0.5rem 0.21rem;
  }

  .game-info-strategy {
    margin-top: 0.3rem;
  }
}

.ipad {
  .game-info-detail {
    &-wrap {
      width: 100%;
    }

    .game-info-main {
      background-color: white;
      padding: 1.7rem 0.5rem 0.5rem 0.3rem;
    }
  }
}
</style>
